import React from "react"
import { USER_ROLE } from "../../@constants/user"
import { AUDIT_LOG_ROUTES } from "../../@constants/routes"
import AppLayout from "Layout"
import AuditLogPage from "./index"

const AuditLogRoutes = {
    path: AUDIT_LOG_ROUTES.PATH,
    title: AUDIT_LOG_ROUTES.TITLE,
    subtitle: AUDIT_LOG_ROUTES.SUBTITLE,
    icon: 'clock-rotate-left',
    iconWeight: 'light',
    access: USER_ROLE.ADMIN,
    element: <AppLayout />,
    children: [{
        element: <AuditLogPage />,
        index: true
    }]
}

export default AuditLogRoutes
